import axios from "axios";
import { getApiBase } from "../apiBase";

function baseUrl(apiUrl) {
  return apiUrl || getApiBase();
}

export async function syncCrmCompaniesFromProjects({ apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(
    `${baseUrl(apiUrl)}/crm/companies/sync`,
    {},
    { headers: getAuthHeaders?.() }
  );
  return data;
}

export async function fetchCrmCompanies({ apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/crm/companies`, {
    headers: getAuthHeaders?.(),
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchCrmCompany(id, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/crm/companies/${id}`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function createCrmCompany(body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(`${baseUrl(apiUrl)}/crm/companies`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function updateCrmCompany(id, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.patch(`${baseUrl(apiUrl)}/crm/companies/${id}`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function deleteCrmCompany(id, { apiUrl, getAuthHeaders } = {}) {
  await axios.delete(`${baseUrl(apiUrl)}/crm/companies/${id}`, {
    headers: getAuthHeaders?.(),
  });
}

export async function fetchCrmPeople({ companyId, apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/crm/people`, {
    headers: getAuthHeaders?.(),
    params: companyId ? { companyId } : undefined,
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchCrmPerson(id, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/crm/people/${id}`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function createCrmPerson(body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(`${baseUrl(apiUrl)}/crm/people`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function updateCrmPerson(id, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.patch(`${baseUrl(apiUrl)}/crm/people/${id}`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function deleteCrmPerson(id, { apiUrl, getAuthHeaders } = {}) {
  await axios.delete(`${baseUrl(apiUrl)}/crm/people/${id}`, {
    headers: getAuthHeaders?.(),
  });
}

export async function fetchCrmOpportunities({ companyId, apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/crm/opportunities`, {
    headers: getAuthHeaders?.(),
    params: companyId ? { companyId } : undefined,
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchCrmOpportunity(id, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/crm/opportunities/${id}`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function createCrmOpportunity(body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(`${baseUrl(apiUrl)}/crm/opportunities`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function updateCrmOpportunity(id, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.patch(`${baseUrl(apiUrl)}/crm/opportunities/${id}`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function deleteCrmOpportunity(id, { apiUrl, getAuthHeaders } = {}) {
  await axios.delete(`${baseUrl(apiUrl)}/crm/opportunities/${id}`, {
    headers: getAuthHeaders?.(),
  });
}

export async function closeCrmOpportunity(id, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(
    `${baseUrl(apiUrl)}/crm/opportunities/${id}/close`,
    {},
    { headers: getAuthHeaders?.() }
  );
  return data;
}

export async function setCrmOpportunityProjects(id, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.put(`${baseUrl(apiUrl)}/crm/opportunities/${id}/projects`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}
